import React from 'react';
import PropTypes from 'prop-types';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import {
    costAccountingAudit,
    costAccountingDistributionPlans,
    costAccountingMappings,
    costAccountingOverrides,
    costAccountingPeriods,
    costAccountingProfitability,
    costAccountingQueue,
} from '../../constants/constants';

const tabs = [
    { label: 'Queue', value: costAccountingQueue },
    { label: 'Mappings', value: costAccountingMappings },
    { label: 'Distribution', value: costAccountingDistributionPlans },
    { label: 'Overrides', value: costAccountingOverrides },
    { label: 'Periods', value: costAccountingPeriods },
    { label: 'Audit', value: costAccountingAudit },
    { label: 'Profitability', value: costAccountingProfitability },
];

class CostAccountingContainer extends React.Component {
    handleTabChange = (event, value) => {
        this.props.history.push(value);
    };

    render() {
        const { children, history } = this.props;
        const selectedTab = tabs.find(tab => history.location.pathname.indexOf(tab.value) === 0);
        return (
            <React.Fragment>
                <AppBar position="static" color="default">
                    <Tabs
                        value={selectedTab ? selectedTab.value : costAccountingQueue}
                        onChange={this.handleTabChange}
                        indicatorColor="primary"
                        textColor="primary"
                    >
                        {tabs.map(tab => <Tab key={tab.value} label={tab.label} value={tab.value} />)}
                    </Tabs>
                </AppBar>
                <div className="p-2">
                    {children}
                </div>
            </React.Fragment>
        );
    }
}

CostAccountingContainer.propTypes = {
    children: PropTypes.node,
    history: PropTypes.object.isRequired,
};

CostAccountingContainer.defaultProps = {
    children: null,
};

export default CostAccountingContainer;
